import { useTranslations } from 'next-intl';
import CoreDepositTooltip from 'components/price/discount-price/core-deposit-tooltip';
import CoreDepositMobileDrawer from 'components/price/discount-price/core-deposit-mobile-drawer';
import cx from 'classnames';
import styles from 'components/price/price.module.scss';
import {
  checkIsRiyal,
  getRiyalFormattedPrice
} from 'app/[lang]/[esite]/utils/paymentUtils';
import { PriceAvailabilityResponseHeadless } from 'services/priceAvailability/types';

interface DiscountPrice {
  price: PriceAvailabilityResponseHeadless['items'][0];
  isCoreDepositMobileDrawer?: boolean;
  isProductOverview: boolean;
  currency: string;
  isMobile?: boolean;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
}

const DiscountPrice = ({
  price,
  isCoreDepositMobileDrawer = false,
  isProductOverview = true,
  currency = '',
  isMobile = false,
  isRTL = false,
  currencyLdFeatureFlag = false
}: DiscountPrice) => {
  const t = useTranslations();
  const showDiscountPrice =
    price?.price?.formatted?.unitPrice !==
    price?.price?.formatted?.discountedPrice;
  const saudiCurrencySymbol = currencyLdFeatureFlag && checkIsRiyal(currency);
  const showPriceValue = () => {
    return `${price?.price?.formatted?.coreCharges} ${isProductOverview ? t('ITEM_EA_ABB') : currency}`;
  };
  return (
    <>
      {showDiscountPrice &&
        isProductOverview &&
        (saudiCurrencySymbol ? (
          <p>
            {getRiyalFormattedPrice({
              price: `${price?.price?.formatted?.unitPrice} ${t('ITEM_EA_ABB')}`,
              priceWrapperClasses: cx(
                'm-0 text-decoration-line-through px-1',
                styles['gray-text'],
                { ' cat-u-theme-typography-footnote': isMobile }
              ),
              isRTL: isRTL,
              size: 'sm'
            })}
          </p>
        ) : (
          <p
            className={cx(
              'm-0 text-decoration-line-through',
              styles['gray-text'],
              { ' cat-u-theme-typography-footnote': isMobile }
            )}
          >
            {`${price?.price?.formatted?.unitPrice}`} {t('ITEM_EA_ABB')}
          </p>
        ))}
      {!!price?.price?.formatted?.coreCharges && (
        <>
          {isCoreDepositMobileDrawer ? (
            <CoreDepositMobileDrawer />
          ) : (
            <CoreDepositTooltip />
          )}
          <p
            className={cx(
              isMobile
                ? 'cat-u-theme-typography-footnote m-0'
                : `m-0 ${styles['gray-text']}`
            )}
          >
            {saudiCurrencySymbol
              ? getRiyalFormattedPrice({
                  price: `${price?.price?.formatted?.coreCharges} ${isProductOverview ? t('ITEM_EA_ABB') : ''}`,
                  priceWrapperClasses: 'px-1',
                  isRTL: isRTL,
                  size: 'xxs'
                })
              : showPriceValue()}
          </p>
        </>
      )}
    </>
  );
};

export default DiscountPrice;
